/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedAssociatedCompanies200,
  GetApiV1PersonSharedAssociatedCompanies400,
  GetApiV1PersonSharedAssociatedCompanies401,
  GetApiV1PersonSharedAssociatedCompanies500,
  GetApiV1PersonSharedAssociatedCompaniesQueryParams,
  GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedAssociatedCompanies.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonSharedAssociatedCompaniesQueryParamsSchema =
  z.object({
    filter: z.string().default(""),
    id: z.optional(z.coerce.number().int()),
    isEnrollment: z.boolean().default(false),
    poloId: z.optional(z.coerce.number().int()),
    companyId: z.optional(z.coerce.number().int()),
    classStudentId: z.optional(z.coerce.number().int()),
  }) as unknown as ToZod<GetApiV1PersonSharedAssociatedCompaniesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedAssociatedCompanies200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1PersonSharedAssociatedCompanies200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1PersonSharedAssociatedCompanies400Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAssociatedCompanies400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedAssociatedCompanies401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAssociatedCompanies401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedAssociatedCompanies500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAssociatedCompanies500>;

export const getApiV1PersonSharedAssociatedCompaniesQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedAssociatedCompanies200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedAssociatedCompaniesQueryResponse>;
